import request from '@/api/base'

// 客户信息
const getCustomerList = (params) => {
  return request.post('/portal/commercialCompany/queryCommercialCompanyList', params)
}
const addCustomerInfo = (params) => {
  return request.post('/portal/commercialCompany/addCommercialCompany', params)
}
const updateCustomerInfo = (params) => {
  return request.post('/portal/commercialCompany/updateCommercialCompany', params)
}
const delCustomerInfo = (params) => {
  return request.post('/portal/commercialCompany/deleteCommercialCompany', params)
}
const queryCustomerInfo = (params) => {
  return request.post('/portal/commercialCompany/queryCommercialCompanyInfo', params)
}

// 项目信息
const getProjectList = (params) => {
  return request.post('/portal/commercialProject/queryCommercialProjectList', params)
}
// 删除项目信息
const deleteCommercialProjectInfo = (params) => {
  return request.post('/portal/commercialProject/deleteCommercialProjectInfo', params)
}
const addProjectInfo = (params) => {
  return request.post('/portal/commercialProject/addCommercialProject', params)
}
const updateProjectInfo = (params) => {
  return request.post('/portal/commercialProject/updateCommercialProject', params)
}
const setProjectStatus = (params) => {
  return request.post('/portal/commercialProject/setCommercialProjectStatus', params)
}
const viewProjectInfo = (params) => {
  return request.post('/portal/commercialProject/queryCommercialProjectInfo', params)
}
const latest = (params) => {
  return request.post('/portal/commercialProgressProject/info/latest', params)
}
const content = (params) => {
  return request.post('/portal/commercialDockingRecord/list/content', params)
}
const peopleList = (params) => {
  return request.post('/portal/park/user/findParkUsers', params)
}
// 意向房源
const updateProjectAddress = (params) => {
  return request.post('/portal/commercialProject/updateProjectAddress', params)
}
// 项目信息首页统计
const homePage = (params) => {
  return request.post('/portal/commercialProject/homePage', params)
}

// 对接记录
const getDockingRecordList = (params) => {
  return request.post('/portal/commercialDockingRecord/list', params)
}
const getDockingRecordDetail = (params) => {
  return request.post('/portal/commercialDockingRecord/info', params)
}
const addDockingRecord = (params) => {
  return request.post('/portal/commercialDockingRecord/add', params)
}
const updateDockingRecord = (params) => {
  return request.post('/portal/commercialDockingRecord/update', params)
}
const saveAttachent = (params) => {
  return request.post('/portal/message/saveAttachent', params)
}
const deleteDockingRecord = (params) => {
  return request.post('/portal/commercialDockingRecord/delete', params)
}

// 项目进展填报
const getProjectProcessList = (params) => {
  return request.post('/portal/commercialProgressProject/list', params)
}
const getProjectProcessDetail = (params) => {
  return request.post('/portal/commercialProgressProject/info', params)
}
const updateProjectProcess = (params) => {
  return request.post('/portal/commercialProgressProject/update', params)
}

// 装修进展填报
const getDecorationProcessList = (params) => {
  return request.post('/portal/commercialProgressDecoration/list', params)
}
const getDecorationProcessDetail = (params) => {
  return request.post('/portal/commercialProgressDecoration/info', params)
}
const updateDecorationProcess = (params) => {
  return request.post('/portal/commercialProgressDecoration/update', params)
}

// 会议记录
const getMeetingList = (params) => {
  return request.post('/portal/commercialMeetingRecord/list', params)
}
const addMeettingRecord = (params) => {
  return request.post('/portal/commercialMeetingRecord/add', params)
}
const meetingRecordInfo = (params) => {
  return request.post('/portal/commercialMeetingRecord/info', params)
}
const updateMeettingRecord = (params) => {
  return request.post('/portal/commercialMeetingRecord/update', params)
}
const deleteMeetingRecord = (params) => {
  return request.post('/portal/commercialMeetingRecord/delete', params)
}

// 查询公司部门
const departmentBook = (params) => {
  return request.post('/portal/department/departmentBook', params)
}

// 查询部门人员信息
const getDepartmentUserInfo = (params) => {
  return request.post('/portal/department/getDepartmentUserInfo', params)
}
const findParkUsersByNotInRoleId = (params) => {
  return request.post('/portal/park/user/findParkUsersByNotInRoleId', params)
}
const getRoleGroups = (params) => {
  return request.post('/portal/roleGroup/getRoleGroups', params)
}

// 填报设置
const getFillingList = (params) => {
  return request.post('/portal/commercialProgressSet/list', params)
}
const saveFilling = (params) => {
  return request.post('/portal/commercialProgressSet/save', params)
}

// 查询设置管理权限
const commercialProjectPeopleList = (params) => {
  return request.post('/portal/commercialProjectPeople/list', params)
}
// 设置管理权限
const setcCommercialProjectPeople = (params) => {
  return request.post('/portal/commercialProjectPeople/saveDeptHead', params)
}

export default {
  getCustomerList,
  addCustomerInfo,
  updateCustomerInfo,
  delCustomerInfo,
  queryCustomerInfo,
  getProjectList,
  addProjectInfo,
  updateProjectInfo,
  setProjectStatus,
  viewProjectInfo,
  latest,
  content,
  peopleList,
  updateProjectAddress,
  homePage,
  getDockingRecordList,
  getDockingRecordDetail,
  addDockingRecord,
  updateDockingRecord,
  saveAttachent,
  deleteDockingRecord,
  getProjectProcessList,
  getDecorationProcessList,
  getMeetingList,
  addMeettingRecord,
  meetingRecordInfo,
  updateMeettingRecord,
  deleteMeetingRecord,
  deleteCommercialProjectInfo,
  getProjectProcessDetail,
  updateProjectProcess,
  getFillingList,
  saveFilling,
  getDecorationProcessDetail,
  updateDecorationProcess,
  departmentBook,
  getDepartmentUserInfo,
  findParkUsersByNotInRoleId,
  getRoleGroups,
  commercialProjectPeopleList,
  setcCommercialProjectPeople
}



// WEBPACK FOOTER //
// ./src/area-contract/api/investmentService.js